export default __webpack_public_path__ + "static/media/health.b50a34ea.png";